import { getCookie } from 'cookies-next';

import { syncAnonymousUserWithIpCookie } from '@v2/containers/CurrencyPicker/syncAnonymousUserWithIpCookie';
import { getUserIpAddress } from './ip-tracking';

let initializationPromise: Promise<void> | null = null;

export async function initializeClientContext() {
  if (!initializationPromise) {
    initializationPromise = (async () => {
      if (!getUserIpAddress()) {
        await fetch('/api/client-context', {
          cache: 'no-store',
          credentials: 'same-origin',
        });
      }

      await syncAnonymousUserWithIpCookie();

      const anonymousUserId = getCookie('anonymous-user-id')?.toString();
      if (anonymousUserId) {
        (window as any).clarity?.('set', 'anonymousUserId', anonymousUserId);
      }

      window.dispatchEvent(new Event('client-context-ready'));
    })().catch((error) => {
      initializationPromise = null;
      throw error;
    });
  }

  return initializationPromise;
}
